import { format } from 'date-fns';
import ConcludeAnimation from '@/components/animations/ConcludeAnimation';
import { Tick } from '@/components/icons';
import { EMPTY_VALUE } from '@/constants';
import { getAge } from '@/utils';
import { DarkBlueLogo } from '../brand';
import { ReportData as Report } from '../preview/types';

interface ReportCompletionProps {
    reportData: Report;
}

export default function ReportCompletion({ reportData }: ReportCompletionProps) {
    return (
        <div className="relative">
            {/* Confetti */}
            <div className="pointer-events-none absolute inset-0 -mt-10 overflow-hidden">
                <ConcludeAnimation />
            </div>
            {/* Success Icon */}
            <div className="relative z-10 mb-6 flex justify-center">
                <div className="flex size-16 items-center justify-center rounded-full bg-green-500">
                    <Tick className="size-8 text-white" />
                </div>
            </div>
            <h2 className="mb-2 text-center text-2xl font-bold text-foreground">
                Relatório Concluído!
            </h2>
            <p className="mb-6 text-center text-sm text-muted-foreground">
                Parabéns! Seu laudo psicológico foi finalizado com sucesso
            </p>
            {/* Report Details Card */}
            <div className="mb-6 rounded-xl border border-border bg-surface p-4">
                <div className="mb-3 flex items-center gap-3">
                    <DarkBlueLogo />
                    <div className="font-semibold text-foreground">
                        {reportData?.patient?.full_name || 'Laudo Psicológico'}
                    </div>
                </div>

                <div className="space-y-2 text-sm text-foreground">
                    <div className="flex items-center gap-2">
                        <span className="text-muted-foreground">•</span>
                        <span>Paciente: {reportData?.patient?.full_name || EMPTY_VALUE}</span>
                    </div>
                    <div className="flex items-center gap-2">
                        <span className="text-muted-foreground">•</span>
                        <span>
                            Idade:{' '}
                            {reportData?.patient?.date_of_birth
                                ? `${getAge(reportData?.patient?.date_of_birth)} anos`
                                : EMPTY_VALUE}
                        </span>
                    </div>
                    <div className="flex items-center gap-2">
                        <span className="text-muted-foreground">•</span>
                        <span>
                            Período:{' '}
                            {reportData?.tests_performed_at_start
                                ? `${format(
                                      new Date(reportData.tests_performed_at_start),
                                      'dd/MM/yyyy',
                                  )} ${
                                      reportData.tests_performed_at_end
                                          ? `- ${format(
                                                new Date(reportData.tests_performed_at_end),
                                                'dd/MM/yyyy',
                                            )}`
                                          : ''
                                  }`
                                : EMPTY_VALUE}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}
